<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="eventDetail">
    <!-- event flow -->
    <template v-if="canShowIntroduceVideo">
      <h2 class="eventDetail-headingLarge">コンテンツ紹介Movie</h2>
      <div class="videoBlock">
        <iframe
          src="https://www.youtube.com/embed/GN38HkvE3o4"
          width="100%"
          height="auto"
          frameborder="0"
          class="marginB3"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <iframe
          src="https://www.youtube.com/embed/uI_K7mDUScY"
          width="100%"
          height="auto"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </template>

    <div v-if="shouldParticipationSectionHaveOverviewId" id="overview" class="tab-target-inner">
      <intersection-observer @element-in-view="elementInView('overview')">
        <h2 class="opixNews eventDetail-headingLarge event-detail-heading event-detail-application-status">申し込み状況</h2>
      </intersection-observer>
      <div class="contentBlock">
        <article v-for="(section, sIdx) in detailMainSection.sections" :key="`contentSection-${sIdx}`" class="detailArticle detail-main-article">
          <header>
            <div class="grayColor">{{ formatNewsDate(section.updated_at) }}</div>
          </header>

          <div class="detail-main-article__content">
            <article v-if="hasParticipantCount(section)" class="detail-main-article__content-section">
              <h3 class="eventDetail-headingSmall">最新の予約情報</h3>
              <dl class="participant-count">
                <div class="participant-count__count-by-gender">
                  <dt class="participant-count__gender-label participant-count__male-label">
                    <Icon icomoon="male" class="blueSky" :size="2" /><span class="align-bottom-text">男性</span>
                  </dt>
                  <dd>
                    <span class="align-bottom-text">{{ section.male_participant_count || 0 }}</span
                    ><span>名</span>
                  </dd>
                </div>
                <div class="participant-count__count-by-gender">
                  <dt class="participant-count__gender-label participant-count__female-label">
                    <Icon icomoon="female" class="pinkDark" :size="2" /><span class="align-bottom-text">女性</span>
                  </dt>
                  <dd>
                    <span class="align-bottom-text">{{ section.female_participant_count || 0 }}</span
                    ><span>名</span>
                  </dd>
                </div>
              </dl>
            </article>

            <hr v-if="hasParticipantCount(section) && section.title" class="dotted-separator" aria-hidden="true" />

            <article v-if="section.title" class="detail-main-article__content-section">
              <h3 class="eventDetail-headingSmall">{{ section.title }}</h3>
              <div class="detailArticle-content textJustify" v-html="$sanitizedXssHtml(filterOtoconContent(section.content))" />
            </article>
          </div>
        </article>
      </div>
    </div>

    <template v-if="event.display_new_page">
      <div :id="!shouldParticipationSectionHaveOverviewId ? 'overview' : null" class="tab-target-inner">
        <intersection-observer @element-in-view="elementInView('overview')" @element-not-in-view="elementNotInView('overview')">
          <h2 ref="eventContent" class="opixEventContent eventDetail-headingLarge event-detail-heading">{{ eventContentSectionTitle }}</h2>
        </intersection-observer>
        <div class="contentBlock detail-article-list">
          <template v-if="detailContentSection">
            <template v-for="(section, sIdx) in detailContentSection.sections" :key="`contentSection-${sIdx}`">
              <article class="detailArticle">
                <intersection-observer @element-in-view="elementInView('overview')">
                  <h3 class="eventDetail-headingSmall">{{ section.title }}</h3>
                </intersection-observer>
                <figure v-if="sIdx === 0 && section.video_url" class="detailArticle-content-iframe">
                  <video-iframe
                    :video-url="section.video_url"
                    :video-aspect-ratio="section.video_aspect_ratio"
                    :platform-type="section.video_platform"
                  />
                </figure>
                <figure v-if="section.image">
                  <common-lazy-load-image
                    v-if="event.need_change_section_content_image && sIdx === 0"
                    :src="whitekeyEventContentAlterImg"
                    alt="感染対策の様子"
                  />
                  <common-lazy-load-image v-else :image-object="section.image" :alt="section.image.alt" />
                  <div class="event-content-image-caption">
                    <figcaption class="textJustify grayColor" v-html="$sanitizedXssHtml(section.caption)" />
                  </div>
                </figure>
                <div
                  ref="infoContent"
                  :class="{ spacePre: tagPContent > 1 }"
                  class="detailArticle-content textJustify"
                  v-html="$sanitizedXssHtml(filterOtoconContent(section.content))"
                />
              </article>
              <hr v-if="sIdx < detailContentSection.sections.length - 1" class="dotted-separator" aria-hidden="true" />
            </template>
          </template>

          <p v-else class="marginT4">イベントの内容はありません</p>
        </div>
      </div>
    </template>
    <div v-else :id="!shouldParticipationSectionHaveOverviewId ? 'overview' : null" class="tab-target-inner">
      <intersection-observer @element-in-view="elementInView('overview')" @element-not-in-view="elementNotInView('overview')">
        <h2 ref="eventContent" class="opixEventContent eventDetail-headingLarge event-detail-heading">{{ eventContentSectionTitle }}</h2>
      </intersection-observer>
      <div class="contentBlock detail-article-list">
        <template v-for="(content, cIdx) in detailContentsForNotNewPage" :key="`content-${cIdx}`">
          <template v-for="(section, sIdx) in content.sections" :key="`contentSection-${sIdx}`">
            <article class="detailArticle">
              <intersection-observer @element-in-view="elementInView('overview')">
                <h3 class="eventDetail-headingSmall">{{ section.title }}</h3>
              </intersection-observer>
              <figure v-if="sIdx === 0 && section.video_url" class="detailArticle-content-iframe">
                <video-iframe
                  :video-url="section.video_url"
                  :video-aspect-ratio="section.video_aspect_ratio"
                  :platform-type="section.video_platform"
                />
              </figure>
              <figure v-if="event.need_change_section_content_image || section.image">
                <common-lazy-load-image
                  v-if="event.need_change_section_content_image && sIdx === 0 && section.image"
                  :src="whitekeyEventContentAlterImg"
                  alt="感染対策の様子"
                />
                <common-lazy-load-image v-else :image-object="section.image" :alt="section.alt" />
                <div class="event-content-image-caption">
                  <figcaption class="textJustify grayColor" v-html="$sanitizedXssHtml(section.caption)" />
                </div>
              </figure>
              <div
                ref="infoContent"
                :class="{ spacePre: tagPContent > 1 }"
                class="detailArticle-content textJustify"
                v-html="$sanitizedXssHtml(filterOtoconContent(section.content))"
              />
            </article>
            <hr v-if="sIdx < content.sections.length - 1" class="dotted-separator" aria-hidden="true" />
          </template>
        </template>
      </div>
    </div>
    <div v-if="displayEventFlow" id="eventFlow" class="tab-target-inner">
      <intersection-observer @element-in-view="elementInView('eventFlow')" @element-not-in-view="elementNotInView('eventFlow')">
        <h2 ref="eventFlow" class="opixEventFlow eventDetail-headingLarge event-detail-heading">当日の流れ</h2>
      </intersection-observer>
      <div class="eventFlow contentBlock noPadding">
        <p class="eventFlow-note">※当日のスケジュールは予告なく変更になる場合がございます。</p>
        <ul class="eventFlow-list flowList">
          <li v-for="(flow, idx) in detail.flows" :key="`flow-${idx}`" class="flowList-item">
            <div class="flowList-item-time">{{ flow.time_format }}</div>
            <div class="flowList-item-content">
              <div class="title">{{ flow.title }}</div>
              <div v-if="flow.description" class="textJustify desc" v-html="$sanitizedXssHtml(flow.description)" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <template v-if="canShowEveOnline">
      <h2 class="eventDetail-headingLarge">ここがお得</h2>
      <div class="contentBlock commonCard eventDetail-eveEvent">
        <img :src="imgTokuten" alt="特典" />
      </div>
    </template>
    <template v-if="detailShopInfo">
      <h2 ref="detailShopInfo" class="eventDetail-headingLarge">{{ detailShopInfo.category_text }}</h2>
      <div class="contentBlock commonCard">
        <ul class="placeList">
          <li v-for="(section, idx) in detailShopInfo.sections" :key="idx" class="placeList-item">
            <h3 class="placeList-item-title">{{ section.title }}</h3>
            <figure>
              <common-lazy-load-image v-if="section.image" :image-object="section.image" :alt="section.alt" />
              <figcaption class="textJustify" v-html="$sanitizedXssHtml(section.caption)" />
            </figure>
          </li>
        </ul>
      </div>
    </template>
    <!-- event place -->
    <div v-if="!isOnlineEvent" id="receptionPlace" class="tab-target-inner">
      <intersection-observer
        v-if="!isOnlineEvent"
        @element-in-view="elementInView('receptionPlace')"
        @element-not-in-view="elementNotInView('receptionPlace')"
      >
        <h2 id="receptionPlaceHeading" ref="receptionPlace" class="opixEventPlace eventDetail-headingLarge event-detail-heading">受付場所</h2>
      </intersection-observer>
      <div v-if="canShowAddress" class="contentBlock">
        <p v-if="detail.no_reception_place" class="eventDetail-empty">受付場所は開催の2日前までにこちらに掲載します。</p>
        <template v-else>
          <h3 v-if="event.place" class="eventDetail-headingTiny">{{ event.place }}</h3>
          <div :class="{ marginT4: !event.place }" class="place marginB4">
            <iframe
              v-if="accessPlace.address_for_map_url"
              :src="accessPlace.address_for_map_url"
              title="mapFrame"
              width="800"
              height="600"
              frameborder="0"
              style="border: 0"
              allowfullscreen
              loading="lazy"
            ></iframe>
          </div>
          <table class="commonTable wide reception-place-details">
            <tbody>
              <tr v-if="accessPlace.address_full">
                <th>住所</th>
                <td class="textJustify" v-html="$sanitizedXssHtml(accessPlace.address_full)" />
              </tr>
              <tr v-if="canShowAddressLocation">
                <th>立地</th>
                <td class="textJustify">{{ $useI18(`event.attributes.address_location.${accessPlace.address_location}`) }}</td>
              </tr>
              <tr v-if="canShowAddressVenue">
                <th>会場</th>
                <td class="textJustify">
                  {{
                    !accessPlace.address_venue_other
                      ? $useI18(`event.attributes.address_venue.${accessPlace.address_venue}`)
                      : accessPlace.address_venue_other
                  }}
                </td>
              </tr>
              <tr v-if="accessPlace.address_parking_lot != 'no_show'">
                <th>駐車場</th>
                <td class="textJustify">{{ $useI18(`event.attributes.address_parking_lot.${accessPlace.address_parking_lot}`) }}</td>
              </tr>
              <tr v-if="accessPlace.access">
                <th>アクセス</th>
                <td class="textJustify" v-html="$sanitizedXssHtml(accessPlace.access)" />
              </tr>
            </tbody>
          </table>
        </template>
        <div v-if="detail.access_video && detail.access_video.video_url" class="marginT4">
          <figure class="detailArticle-content-iframe">
            <video-iframe
              :video-url="detail.access_video.video_url"
              :video-aspect-ratio="detail.access_video.video_aspect_ratio"
              :platform-type="detail.access_video.video_platform"
            />
          </figure>
        </div>
        <div v-if="accessPlace.access_images.length > 0">
          <figure v-for="(accessImg, idx) in accessPlace.access_images" :key="idx" class="marginT4">
            <common-lazy-load-image :image-object="accessImg.image" />
            <figcaption class="reception-image-caption" v-html="$sanitizedXssHtml(accessImg.caption)" />
          </figure>
        </div>
      </div>
      <div v-else class="contentBlock commonCard">
        <p class="eventDetail-empty">受付場所はご購入完了後にこちらに表示されます。</p>
      </div>
    </div>
    <div v-if="event.external_site_url && !isBarGourmetEvent && !isCancelledEvent" class="externalLink">
      <h3 class="eventDetail-headingLarge">リンク</h3>
      <div class="externalLink-link contentBlock commonCard textJustify">
        <a :href="event.external_site_url" target="_blank">{{ event.external_site_text || 'ホームページはこちら（外部サイトへ）' }}</a>
      </div>
    </div>
  </div>
</template>

<script>
const CommonLazyLoadImage = defineAsyncComponent(() => import('@/components/CommonLazyLoadImage.vue'))
import OnlineEventMixin from '@/utils/mixins/OnlineEventMixin'
import moment from 'mj-moment'
import whitekeyEventContentAlterImg from '/assets/images/whitekey_event_content_alter_img.jpg'
import imgTokuten from '/assets/images/img_tokuten.png'
const VIDEO_EVENT_CODE = 'HELDbc'
const OTOCON_CASHLESS_TEXT =
  '----<br>■会場でもキャッシュレス決済がご利用いただけます！■<br><br>この度、オトコンでは会場でのキャッシュレス決済を導入いたしました。<br>ぜひ、この機会にご活用ください！<br><br>◆ご利用可能決済ブランド<br>クレジットカード：VISA・MasterCard・JCB・AMERICAN EXPRESS・Diners Clubなど<br>電子マネー：WAON・交通系・ID決済・QUICPay<br>バーコード：メルPay・auPAY・FamiPay・d払いなど<br>※一部ご利用いただけない決済もございます。詳細はお問い合わせくださいませ。<br>※申込み先によっては、ご利用いただけない場合がございますので、予めご確認くださいませ。<br>-------------------------------------------------------<br><br>'
const OTOCON_ORGANIZER_NAME = 'OTOCON（おとコン）'
const VideoIframe = defineAsyncComponent(() => import('@/components/VideoIframe.vue'))
export default {
  components: { CommonLazyLoadImage, VideoIframe },
  mixins: [OnlineEventMixin],
  props: {
    event: { type: Object, default: null, required: true },
    canShowAddress: { type: Boolean, default: true, required: false },
    isFemalePage: { type: Boolean, default: false, required: false }
  },
  emits: ['handleElementInView', 'handleElementNotInView'],
  data() {
    return {
      tagPContent: 0,
      whitekeyEventContentAlterImg,
      imgTokuten
    }
  },
  computed: {
    detail() {
      return this.event.detail
    },
    // old event and imported api events
    detailContentsForNotNewPage() {
      return this.detail.contents.filter(v => !v.shop && !v.organizer_message && !v.female_recommend && !v.main && v.sections.length > 0)
    },
    detailShopInfo() {
      return this.detail.contents.find(v => v.shop && v.sections.length)
    },
    detailMainSection() {
      return this.detail.contents.find(v => v.main && v.sections.length > 0)
    },
    detailInformationSection() {
      return this.detail.contents.find(v => v.information && v.sections.length > 0)
    },
    detailFemaleRecommendSection() {
      return this.detail.contents.find(v => v.female_recommend && v.sections.length > 0)
    },
    detailContentSection() {
      return this.shouldShowFemaleRecommendAsEventContent ? this.detailFemaleRecommendSection : this.detailInformationSection
    },
    shouldShowFemaleRecommendAsEventContent() {
      return this.isFemalePage && this.detailFemaleRecommendSection
    },
    eventContentSectionTitle() {
      if (this.shouldShowFemaleRecommendAsEventContent) {
        return '女性におすすめの理由'
      }
      return 'イベントの内容'
    },
    accessPlace() {
      return this.detail.access_place
    },
    isCancelledEvent() {
      return this.event.status === 'cancelled'
    },
    isBarGourmetEvent() {
      return this.event.type === 'bar_gourmet'
    },
    displayEventFlow() {
      return !this.isBarGourmetEvent || this.event.display_event_flow
    },
    canShowIntroduceVideo() {
      return this.event.code === VIDEO_EVENT_CODE
    },
    canShowEveOnline() {
      return (
        this.event.eve_online && this.event.datetime_can_participate_eve_online && moment().diff(this.event.datetime_can_participate_eve_online) < 0
      )
    },
    canShowAccordionForPlace() {
      return this.$store.isSP && !this.detail.no_reception_place && (this.accessPlace.access || this.accessPlace.access_images.length > 0)
    },
    canShowAddressLocation() {
      return !this.accessPlace.address_location ? false : this.accessPlace.address_location !== 'no_show'
    },
    canShowAddressVenue() {
      if (!this.accessPlace.address_venue) return false
      return this.accessPlace.address_venue !== 'no_show'
    },
    isOtoconEvent() {
      return this.event.organizer_name === OTOCON_ORGANIZER_NAME
    },
    hasMainSectionContent() {
      const mainSection = this.detailMainSection
      if (!mainSection || !mainSection.sections) return false
      return mainSection.sections.some(section => this.hasParticipantCount(section) || Boolean(section.title))
    },
    shouldParticipationSectionHaveOverviewId() {
      return (this.event.display_new_page || this.event.is_external_event) && this.hasMainSectionContent
    }
  },
  mounted() {
    this.countTagPContent()
  },
  methods: {
    formatNewsDate(date) {
      return moment(date).locale('en').format('YYYY.MM.DD ddd').toLowerCase()
    },
    countTagPContent() {
      if (!this.$refs.infoContent) return

      this.tagPContent = this.$refs.infoContent[0].childElementCount
      const children = this.$refs.infoContent[0]?.children
      if (children) {
        for (let i = 0; i < children.length; i++) {
          children[i].innerHTML = children[i].innerHTML.replace(/\n/, '')
        }
      }
    },
    elementInView(navigationTab) {
      this.$emit('handleElementInView', navigationTab)
    },
    elementNotInView(navigationTab) {
      this.$emit('handleElementNotInView', navigationTab)
    },
    filterOtoconContent(content) {
      if (!this.isOtoconEvent || !content) return content
      return content.replace(OTOCON_CASHLESS_TEXT, '')
    },
    hasParticipantCount(section) {
      return typeof section.female_participant_count === 'number' || typeof section.male_participant_count === 'number'
    }
  }
}
</script>

<style scoped lang="scss">
.contentBlock {
  padding: 0 2rem 2rem;
  @include sp {
    padding: 0 1.6rem 2rem;
  }
  &.noPadding {
    padding: 0;
  }
}

.videoBlock {
  @extend .contentBlock;
  padding-top: 2rem;
  @include pc {
    cursor: pointer;
  }
}

.eventDetail {
  &-nav {
    @include flex;
    justify-content: space-between;
    margin: 16px 0 32px;
    &-item {
      width: 32.5%;
      &.half {
        width: calc(50% - 1rem);
      }
    }
  }
  &-headingLarge {
    font-size: 1.6rem;
    line-height: 1;
    padding: 20px 0 5px;
    @include sp {
      padding: 20px 16px 10px;
    }
  }
  &-headingSmall {
    font-size: 18px;
  }
  &-headingTiny {
    margin: 0 0 1.5rem;
    font-size: 1.6rem;
    @include pc {
      line-height: 1.2;
    }
  }
  &-empty {
    padding: 2rem 0 0;
    @include pc {
      margin: 2rem 0 0;
      padding: 3rem 1rem;
      border: {
        width: 2px;
        style: solid;
        radius: 3px;
        color: $gray-f1;
      }
      color: $gray-55;
      text-align: center;
    }
  }
  &-eveEvent {
    padding: 1.6rem 1rem 1rem;
  }
}

.commonTable {
  border: none;
  color: $gray-55;
  tr {
    padding-bottom: 8px;
    background: none;
  }
  th,
  td {
    font-weight: normal;
  }
}

.detailArticle {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &-content {
    word-break: break-all;
    line-height: 1.75;
    &.spacePre {
      white-space: pre-line;
    }
    :deep(p) {
      line-height: inherit;
      word-break: break-all;
      margin-bottom: -10px;
    }
    &-iframe {
      @include flex;
      width: 100%;
      margin-bottom: 8px;
    }
  }
  p {
    margin-bottom: 1.5rem;
  }
  figure {
    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: contain;
      aspect-ratio: 4 / 3;
    }
  }
}

.detail-main-article {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.event-content-image-caption {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;

  figcaption {
    border-bottom: 1px dotted $gray-c6;
    font-size: 1.2rem;
    padding-top: 0.6rem;
  }
}

.grayColor {
  color: $gray-55;
}

.eventFlow {
  @include sp {
    margin: 0 1.6rem;
    padding-bottom: 14px;
  }
  &-list {
    padding-bottom: 1.6rem;
  }
  &-note {
    height: 5rem;
    font-size: 12px;
    border-bottom: 1px dotted $gray-c6;
    color: $gray-55;
    padding-top: 16px;
    padding-bottom: 8px;
    display: flex;
    align-items: flex-end;
    @media screen and (max-width: 359px) {
      height: 6rem;
    }
  }
  .flowList {
    &-item {
      @include flex;
      justify-content: flex-start;
      align-items: flex-start;
      position: relative;
      background: $white;
      padding: 16px 0;
      @include sp {
        padding: 16px 0;
      }
      border-bottom: 1px dotted $gray-c6;
      &:last-child {
        border-bottom: none;
        padding-bottom: 20px;
        @include sp {
          padding-bottom: 0;
        }
      }
      &-time {
        width: 7rem;
        min-width: 7rem;
        font-weight: bold;
        @include pc {
          width: 14rem;
          min-width: 14rem;
        }
      }
      &-content {
        .title {
          font-weight: bold;
        }
        .desc {
          color: $gray-55;
          line-height: 1.6;
        }
      }
    }
  }
}

.place {
  position: relative;
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-bottom: 75%;
  @include pc {
    padding-bottom: 56.25%;
  }
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
}

.placeButton {
  margin: 1.6rem 0 2rem;
}

.placeList {
  margin-top: 2rem;
  &-item {
    margin: 0 0 1rem;
    @include pc {
      display: inline-block;
      width: calc(50% - 0.3rem);
      vertical-align: top;
    }
    figure {
      font-size: 1.2rem;
    }
    img {
      width: 100%;
    }
    &-title {
      font-size: 1.4rem;
      font-weight: bold;
      color: $black-1a;
      padding-bottom: 0.6rem;
    }
  }
}

.externalLink {
  font-size: 1.2rem;
  font-weight: 700;
  &-link {
    padding: 2rem;
    @include sp {
      margin: 0 1.6rem;
      padding: 2rem 1.6rem;
    }
    a {
      color: $black-1a;
      text-decoration: underline;
    }
  }
}

.reception-place-details {
  font-size: 14px;
  color: $black-1a;
  line-height: 1.6;

  th {
    font-weight: bold;
  }
}

.reception-image-caption {
  color: $gray-55;
  margin-top: 4px;
}

.dotted-separator {
  border: none;
  border-top: 3px dotted $gray-cc;
  width: 80%;
  max-width: 182px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.detail-article-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.contentBlock.detail-article-list {
  padding: 20px 0;

  .eventDetail-headingSmall,
  .detailArticle-content,
  .event-content-image-caption,
  .detailArticle-content-iframe {
    padding: 0 16px;

    @include pc {
      padding: 0;
    }
  }
}

.participant-count {
  display: flex;
  gap: 16px;
}

.participant-count__count-by-gender {
  display: flex;
  flex: 1;
  gap: 8px;
  align-items: center;
  font-size: 1.6rem;
}

.participant-count__male-label {
  color: $blue-thin-light;
}

.participant-count__female-label {
  color: $pink-hot;
}

.participant-count__gender-label {
  font-weight: bold;
  display: flex;
  gap: 4px;
  align-items: baseline;
}

.detail-main-article__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.detail-main-article__content-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
